/**
 * reCAPTCHA v3 (invisível).
 * A chave do site é obtida da API (GET /api/config/recaptcha) e passada para getRecaptchaToken.
 */
const loadedScripts = {};

function loadScript(siteKey) {
  if (!siteKey || loadedScripts[siteKey]) return Promise.resolve();
  if (typeof window === 'undefined') return Promise.resolve();

  return new Promise((resolve, reject) => {
    if (window.grecaptcha && window.grecaptcha.execute) {
      loadedScripts[siteKey] = true;
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = () => {
      loadedScripts[siteKey] = true;
      resolve();
    };
    script.onerror = () => reject(new Error('reCAPTCHA script failed to load'));
    document.head.appendChild(script);
  });
}

/**
 * Obtém token reCAPTCHA v3 para a ação dada (ex: 'login', 'register').
 * @param {string} action - 'login' ou 'register'
 * @param {string} siteKey - Chave do site (vinda da API /api/config/recaptcha). Se vazia, retorna null.
 */
export async function getRecaptchaToken(action = 'login', siteKey = '') {
  if (!siteKey || typeof siteKey !== 'string') return null;
  const key = siteKey.trim();
  if (!key) return null;
  try {
    await loadScript(key);
    if (!window.grecaptcha || !window.grecaptcha.execute) return null;
    // O Google exige grecaptcha.ready() antes de execute()
    await new Promise((resolve) => {
      if (window.grecaptcha.ready) {
        window.grecaptcha.ready(resolve);
      } else {
        resolve();
      }
    });
    return await window.grecaptcha.execute(key, { action });
  } catch (e) {
    console.warn('[reCAPTCHA]', e.message);
    return null;
  }
}
